<template>
  <Head title="Pathways - Audience" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <segment-page :client="client" :segment="segment" :datasets="datasets" :datablends="datablends"></segment-page>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  segment: Object,
  datasets: Array,
  datablends: Array
});
</script>

